import { Link, NavLink, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, BarChart3, Wallet, ArrowDownLeft, Gift, Users, Megaphone, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function AdminLayout() {
  const { t } = useTranslation();
  const items = [
    { to: "/admin", end: true, label: t("admin.dashboard"), icon: BarChart3 },
    { to: "/admin/deposits", label: t("admin.deposits"), icon: ArrowDownLeft },
    { to: "/admin/withdrawals", label: t("admin.withdrawals"), icon: Wallet },
    { to: "/admin/gift-pool", label: t("admin.giftPool"), icon: Gift },
    { to: "/admin/members", label: t("admin.members"), icon: Users },
    { to: "/admin/broadcast", label: t("admin.broadcast"), icon: Megaphone },
    { to: "/admin/featured", label: t("admin.featured"), icon: Star },
  ];

  return (
    <div className="min-h-screen flex flex-col safe-top safe-bottom">
      <header className="border-b sticky top-0 bg-background/95 backdrop-blur z-30">
        <div className="container max-w-6xl flex items-center gap-3 py-3">
          <Button asChild variant="ghost" size="icon">
            <Link to="/"><ArrowLeft /></Link>
          </Button>
          <h1 className="font-display text-xl font-bold">{t("admin.title")}</h1>
        </div>
        <nav className="container max-w-6xl flex gap-1 overflow-x-auto scrollbar-hidden pb-2">
          {items.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.end}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-colors",
                  isActive ? "bg-primary text-primary-foreground" : "hover:bg-accent"
                )
              }
            >
              <i.icon className="size-4" /> {i.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="flex-1 container max-w-6xl py-6">
        <Outlet />
      </main>
    </div>
  );
}
